import React from 'react';

import {observer} from 'mobx-react';
import styles from "./../../../styles/game-center-header-status.module.scss";
import classNames from "classnames";
import {GameCenterHeaderModuleDetailsStatusGameTimeLabel} from "./game-center-header-module.details.status-game-time-label";

export const GameCenterHeaderModuleDetailsShortStatus = observer(({controller}) => {
  const {state} = controller;
  const {displayStatusTextNearGameTime, shortStatusText} = state;

  return (
    <>
      {
        displayStatusTextNearGameTime ? <div className={classNames(styles.status_text)}>{shortStatusText}</div> : null
      }
      <GameCenterHeaderModuleDetailsStatusGameTimeLabel controller={controller}/>
    </>
  );
});
